/**
 * Subscription Entity Definition
 */
import { SubscriptionRelationSchema } from "../schemas/relations";
import { defineEntity } from "./core";
import { getLazyBotConfigEntityDef, getLazyUserEntityDef } from "./lazy-refs";
import { PaymentMethodEntityDef } from "./payment-method.entity";
import { PricingModelEntityDef, StrategyEntityDef } from "./strategy.entity";
export const SubscriptionEntityDef = defineEntity({
    name: "subscription",
    schema: SubscriptionRelationSchema,
    relations: {
        strategy: { type: "one", entity: () => StrategyEntityDef },
        pricingModel: { type: "one", entity: () => PricingModelEntityDef },
        pm_paymentMethod: { type: "one", entity: () => PaymentMethodEntityDef },
        bot_config: { type: "one", entity: getLazyBotConfigEntityDef },
        pm_user: { type: "one", entity: getLazyUserEntityDef },
    },
});
